module.exports = __webpack_public_path__ + "media/images/drivu_white_logo-89c5f46098b411d50b40469db0916ada.png";